export default __webpack_public_path__ + "static/media/room2_2.1325298e.jpg";